module.exports = __webpack_public_path__ + "img/mpcode.54b93d31.png";